const types = {
  small: 'small',
  standard: 'standard',
  large: 'large',
};

export default types;
